import React, { forwardRef, useEffect, useRef } from "react";

type CheckBoxProps = React.InputHTMLAttributes<HTMLInputElement> & {
  indeterminate?: boolean;
};

const CheckBox = forwardRef<HTMLInputElement, CheckBoxProps>(
  ({ indeterminate = false, ...rest }, ref) => {
    const innerRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
      if (innerRef.current) {
        // A checked box must not also draw the mixed dash.
        innerRef.current.indeterminate = indeterminate && !rest.checked;
      }
    }, [indeterminate, rest.checked]);

    return (
      <>
        <input
          {...rest}
          type="checkbox"
          ref={(node) => {
            innerRef.current = node;
            if (typeof ref === "function") {
              ref(node);
            } else if (ref) {
              ref.current = node;
            }
          }}
          className="w-4 h-4 text-gray-50 accent-green-600 rounded-md focus:ring-0"
        />
        <label htmlFor="checkbox" className="sr-only">
          checkbox
        </label>
      </>
    );
  }
);
export default CheckBox;
